import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Currency } from 'ha/constants/Currencies';
import { PayoutTypes } from 'ha/services/apiV2/types/PayoutMethods';

export type Transaction = {
  id: number;
  amount: number;
  currency: Currency;
  status: string;
  type: number;
  actualPayoutDate?: string;
  expectedPayoutDate: string;
  engagement?: {
    uuid: string;
    startDate: string;
    endDate: string;
    type: string;
  };
  invoice?: {
    number: string;
    url: string;
  };
  payoutMethod?: {
    guid: string;
    accountDetails: string;
    accountName: string;
    accountType: PayoutTypes;
  };
  tenant?: {
    id: number;
    uuid: string;
    firstName: string;
    lastName: string;
  };
};

export type Response = {
  payouts: Transaction[];
  totalCount: number;
};

export type Query = {
  fromDate?: string;
  limit?: number;
  offset?: number;
  status?: string; // supports multiple coma-separated payout statuses
  excludeStatus?: string; // supports multiple coma-separated payout statuses
  tenancy?: string;
  toDate?: string;
  type?: number; // supports multiple coma-separated payout types
};

const getPayoutTransactions =
  (makeCall: MakeCall) =>
  (userId: number, query: Query): Promise<{ data: Response; status: number }> =>
    makeCall<Response>('GET', `/v2/user/${userId}/payout-transactions`, {
      query,
    });

export default getPayoutTransactions;

export type GetPayoutTransactions = ReturnType<typeof getPayoutTransactions>;
